/* eslint-disable @typescript-eslint/no-explicit-any */
import { isMiniProgram, isWechat, win } from './device'

type ConnectionEffectiveType = 'slow-2g' | '2g' | '3g' | '4g'

type ConnectionType =
  | 'bluetooth'
  | 'cellular'
  | 'none'
  | 'wifi'
  | 'wimax'
  | 'other'
  | 'unknown'

type NetworkType =
  | string
  | 'wifi'
  | '2g'
  | '3g'
  | '4g'
  | '5g'
  | 'unknown'
  | 'none'

interface GetWeixinNetworkTypeResult {
  errMsg: `getNetworkType:ok`
  networkType: NetworkType
  detailtype: NetworkType
  simtype: number
}

const waitWeixinJSBridge = (): Promise<void> => {
  // console.log('[[ Weixin ] WaitWeixinJSBridge ]', win.WeixinJSBridge)
  return new Promise<void>(resolve => {
    if (win.WeixinJSBridge) {
      resolve()
    } else {
      document.addEventListener('WeixinJSBridgeReady' as any, resolve, false)
    }
  })
}

const getWeixinNetworkType = (): Promise<NetworkType> => {
  return new Promise<NetworkType>((resolve, reject) => {
    // console.log('[[ Weixin ] GetWeixinNetworkType ]', win.wx?.getNetworkType)
    if (win.wx?.getNetworkType) {
      win.wx?.getNetworkType({
        success(res: GetWeixinNetworkTypeResult) {
          console.log('[[ Weixin ] Call GetNetworkType Success ]', res)
          const { networkType, detailtype } = res
          if (networkType === 'none' || detailtype === 'none') {
            reject('none')
          } else {
            resolve(detailtype || networkType)
          }
        },
        fail() {
          console.log('[[ Weixin ] Call GetNetworkType Failed ]')
          reject('fail')
        }
      })
    } else {
      resolve('unknown')
    }
  })
}

const analyseNetworkTypFromConnection = () => {
  return new Promise<NetworkType>((resolve, reject) => {
    if ('connection' in navigator) {
      const { downlink, downlinkMax, effectiveType, rtt, type } =
        (navigator.connection as {
          downlink: number
          downlinkMax: number
          effectiveType: ConnectionEffectiveType
          rtt: number
          type: ConnectionType
        }) || {}
      console.log('[[ Network ] navigator connection ]', {
        downlink,
        downlinkMax,
        effectiveType,
        rtt,
        type
      })
      if (type === 'none' || downlinkMax === 0) throw reject('none')
      resolve(type || effectiveType)
    }
    resolve('unknown')
  })
}

export const getNetworkType = async (): Promise<
  NetworkType | ConnectionType | NetworkType
> => {
  if (isWechat || isMiniProgram) {
    await waitWeixinJSBridge()
    return getWeixinNetworkType()
  }
  return analyseNetworkTypFromConnection()
}
